export default "__VITE_ASSET__B4r1M27k__"